<template>
  <div class="row">
    <div class="col-md-6">
      <form id="signatureForm" class="needs-validation" :class="{ 'was-validated': $v.$invalid && form.submitStatus !== null }" @submit="checkForm" method="post" novalidate>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="inputFirstName">First Name</label>
            <input type="text" class="form-control" id="inputFirstName" v-model="form.firstName" placeholder="" required>
            <div class="invalid-feedback">
              Please provide first name.
            </div>
          </div>
          <div class="form-group col-md-6">
            <label for="inputLastName">Last Name</label>
            <input type="text" class="form-control" id="inputFirstName" v-model="form.lastName" placeholder="" required>
            <div class="invalid-feedback">
              Please provide last name.
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="inputTitle">Title/Position</label>
            <input type="text" class="form-control" id="inputTitlePosition" v-model="form.titlePosition" placeholder="" required>
            <div class="invalid-feedback">
              Please provide title/position.
            </div>
          </div>
        </div>
  
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="inputAddress">Address</label>
            <input type="text" class="form-control" id="inputFirstName" v-model="form.address" placeholder="" :disabled="form.inputDisabled" required>
            <div class="invalid-feedback">
              Please provide address.
            </div>
          </div>
        </div>
  
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="inputPhone">Phone</label>
            <the-mask class="form-control" id="inputPhone" v-model="form.phone" :mask="['(###) ###-####']" placeholder="" required />
            <div class="invalid-feedback">
              Please provide a phone number.
            </div>
          </div>
          <div class="form-group col-md-4">
            <label for="inputFax">Fax</label>
            <the-mask class="form-control" id="inputFax" v-model="form.fax" :mask="['(###) ###-####']" placeholder="" />
          </div>
          <div class="form-group col-md-4">
            <label for="inputEmail">Email</label>
            <input type="text" class="form-control" id="inputFirstName" v-model="form.email" placeholder="" required>
            <div class="invalid-feedback">
              Please provide an email.
            </div>
          </div>  
        </div>
  

        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="inputEmail">Website</label>
            <select class="form-control" v-model="form.website.selectedVal">
              <option :value="null">Please select an option</option>
              <option v-for="(option, index) in form.website.options" :value="option.text" :key="index">{{ option.text }}</option>
            </select>
          </div>
        </div>
  
        <div class="form-row">
          <div class="form-group">
            <div class="col-md-12">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="form.showLogo" id="inputShowLogo">
                <label class="form-check-label" for="inputShowLogo">
                  Show Tuff Shed Logo
                </label>
              </div>
            </div>
  
            <div class="col-md-12">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="form.showSocial" id="inputShowSocial" :disabled="form.inputDisabled">
                <label class="form-check-label" for="inputShowSocial">
                  Show Social Media Icons
                </label>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="form.authorizedDealer" @on:change="checkAuthorized()" id="inputAuthorized">
                <label class="form-check-label" for="inputAuthorized">
                  {{ form.authorizedDealerText }}
                </label>
              </div>
            </div>
          </div>
        </div>
  
      </form>
  
    </div>
    <div class="col-md-6">
      <sig-preview :formData="form" v-if="form.showLogo && form.showSocial"></sig-preview>
      <sig-no-logo :formData="form" v-if="!form.showLogo && form.showSocial"></sig-no-logo>
      <sig-no-social :formData="form" v-if="form.showLogo && !form.showSocial"></sig-no-social>
      <sig-no-logo-no-social :formData="form" v-if="!form.showLogo && !form.showSocial"></sig-no-logo-no-social>

      <button @click="copySignature()" data-text="Select Signature" class="btn btn-outline-primary btn-lg btn-select-sig" >
        <span>Select Signature</span>
      </button>


      <p style="text-align: center; width: 100%;">For you savvy users and for you Mac users, grab the source code.<br><br>
      <button class="btn btn-outline-secondary" @click="getSourceCode()" data-toggle="modal" data-target="#sigSourceModal">Get Source Code</button></p>

      <modal :form="form"></modal>

    </div>
    
  </div>
</template>

<script>
  import SigPreview from './Signature-Preview'
  import SigNoLogo from './Signature-NoLogo'
  import SigNoSocial from './Signature-NoSocial'
  import SigNoLogoNoSocial from './Signature-NoLogo-NoSocial'
  import Modal from './Modal'
  import {TheMask} from 'vue-the-mask'
  
  
  export default {
    name: 'signature-form',
    data () {
      return {
        form: {
          titlePosition: 'Title/Position',
          firstName: 'Name',
          lastName: 'Lastname',
          email: 'email@tuffshed.com',
          address: 'Address',
          website: {
            options: [
              // { value: null, text: 'Please select an option' },
              { value: 'https://tuffshed.com', text: 'tuffshed.com' },
              { value: 'https://888tuffshed.com', text: '888tuffshed.com' },
              { value: 'https://tuffshedpro.com', text: 'tuffshedpro.com' },
              { value: 'https://homedepot.com/tuffshed.com', text: 'homedepot.com/tuffshed' }
            ],
            selectedVal: null
          },
          phone: '(303) 474-5530',
          fax: '(303) 474-5530',
          sigSourceCode: '',
          submitStatus: null,
          showLogo: true,
          showSocial: true,
          authorizedDealer: false,
          authorizedDealerText: 'Authorized Home Depot Service Provider',
          showSourceCode: false,
          modalId: 'sigSourceModal',
          modalTitle: 'TS Signature Source Code',
          inputDisabled: false
        }
      }
    },
    computed: {},
    methods: {
      addContactNumber: function (contactNum) {
        if (this.form.contactNumbers.selectedContacts.length < 2) {
          this.form.contactNumbers.selectedContacts.push(contactNum)
        } else {
          alert('Maximum of 2 lines are allowed.')
        }
        this.form.contactNumbers.selectedOption = ''
        this.form.contactNumbers.selectedVal = ''
      },
      checkAuthorized: function () {
        if (this.form.authorizedDealer) {
          this.form.inputDisabled = true
          this.form.showSocial = false
        } else {
          this.form.inputDisabled = false
        }
      },
      checkForm: function (e) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.form.submitStatus = 'ERROR'
        } else {
          // do your submit logic here
          this.form.submitStatus = 'PENDING'
          setTimeout(() => {
            this.form.submitStatus = 'OK'
          }, 500)
        }

        e.preventDefault()
      },
      checkSourceCode: function () {
        this.form.showSourceCode = false
      },
      copySignature: function () {
        let el = document.getElementById('sig-to-copy')
        let range = document.createRange()
        range.selectNodeContents(el)
        let sel = window.getSelection()
        sel.removeAllRanges()
        sel.addRange(range)
        this.copySelectedText()
      },
      copySelectedText: function () {
        let copy
        try {
          copy = document.execCommand('copy')
        } catch (e) {
          copy = false
        }

        return copy
      },
      getSourceCode: function () {
        let el = document.getElementById('sig-to-copy').outerHTML
        this.form.sigSourceCode = el
        this.form.showSourceCode = true
      }
    },
    watch: {},
    validations: {},
    components: {
      SigPreview,
      SigNoLogo,
      SigNoSocial,
      SigNoLogoNoSocial,
      Modal,
      TheMask
    }
  }
</script>

<style lang="scss" scope>

  form {
    background: $ts-color-white;
    border-radius: 10px;
    padding: 25px;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, .25);
    margin-bottom: 25px;
  }

  form label {
    font-weight: bold;
  }

  form button {
    margin-top: 25px;
  }

  #sig-to-copy {
    border: 1px solid $ts-color-light-grey;
    min-height: 154px;
    padding: 10px;
    width: 100%;
    display: inline-block;
    margin-bottom: 25px;
    border-radius: 5px;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, .25);
  }

  .btn-select-sig {
    display: block;
    margin: 25px auto 50px;
  }

</style>
